module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('Hero', {
    attrs: {
      "imageName": "American-Credit-Invoice-Financing.png",
      "altText": "American Credit Invoice Financing"
    }
  }, [
    [_c('h1', [_vm._v("Invoice factoring / accounts receivable financing")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          this.window.location.href = '/register'
        }
      }
    }, [_vm._v("\n          Apply Now\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Need a stable credit provider who can handle all your frequent\n          short-term credit needs? Try us now. See how we get you the money\n          fast.\n          "), _c('a', {
      attrs: {
        "href": "/register"
      }
    }, [_vm._v("Get Started "), _c('i', {
      staticClass: "fa fa-long-arrow-right"
    })])])]
  ], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("How American Credit factoring works")]), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-p"
  }, [_vm._v("\n          We know you want to stay focused on your business instead of\n          burdensome applications or constantly looking for better rates. So we\n          provide industry's best invoice financing rate. We are your one-stop\n          credit provicer for all your short-term credit needs.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-title"
  }, [_vm._v("Here’s how it works")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-title"
  }, [_vm._v("See our process")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/register'
      }
    }
  }, [_vm._v("\n            Apply Now\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), [_c('RowSection', {
    attrs: {
      "img-side": "right",
      "imageName": "blog-section/blog-receivable-factoring-vs-financing.jpg",
      "altText": "Construction engineer making notes from a spreadsheet program on a background of a warehouse",
      "displayCtaButton": false
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('h2', [_vm._v("Invoice/Accounts-Receivable  Factoring vs. Financing")]), _vm._v(" "), _c('p', [_vm._v("\n            What is the Difference between Invoice/AR Factoring and Financing?"), _c('br'), _vm._v("\n            The primary difference between factoring and bank financing with accounts receivables involves the ownership of the invoices."), _c('br'), _c('br'), _vm._v("\n\nRead the full article about "), _c('a', {
          attrs: {
            "href": "https://amcredit.com/static/blog/invoice-accounts-receivable-factoring-vs-financing.html"
          }
        }, [_vm._v("Receivable Financing vs Factoring")])])]
      },
      proxy: true
    }])
  })], _vm._v(" "), [_c('RowSection', {
    attrs: {
      "img-side": "right",
      "imageName": "blog-section/blog-invoice-factoring.jpg",
      "altText": "a smiling woman sitting behind a desk showing a document to a client",
      "displayCtaButton": false,
      "containerClasses": "pt-0"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('h2', [_vm._v("Invoice Factoring Explained")]), _vm._v(" "), _c('p', [_vm._v("\n            What is invoice factoring? What is the purpose of invoice factoring? How does it work? We answer all thse questions and more in this detailed article on invoice factoring."), _c('br'), _c('br'), _vm._v("\n\nRead the full article "), _c('a', {
          attrs: {
            "href": "https://amcredit.com/static/blog/invoice-factoring-explained.html"
          }
        }, [_vm._v("Invoice Factoring Explained")])])]
      },
      proxy: true
    }])
  })], _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback invoice_financing_customer_voice"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "\n              col-10\n              offset-2\n              col-lg-5\n              offset-lg-0\n              user-feedback-content-right\n            "
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Invoice Financing Customer Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("\n              A growing family business keeps you running 24/7. I can't spend\n              days applying and months waiting for a loan. We need a credit\n              provider who can not only provide quick business invoice financing\n              but other cash flow loans for business as well.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("\n                Let’s Talk\n              ")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("\n                American Credit: the difference you can trust\n              ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/register'
      }
    }
  }, [_vm._v("\n                  Apply Now\n                ")]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _vm._m(9)])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#eff9ff"
    }
  }, [_c('div', {
    staticClass: "container new_bluebg benefits"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Better cash flow with invoice/AR factoring")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_Flexible_Terms.png"),
      "alt": "American Credit Business loans Flexible Terms"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Flexible terms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Financing terms are counted by days, as flexible as your\n                    credit needs.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Competitive_Rates.png"),
      "alt": "American Credit Business Loans Competitive Rates"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Competitive rates")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Daily invoice financing rates are lower than our\n                    competitors. No set-up fee for repeated customers.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Tax_Benefits.png"),
      "alt": "American Credit Busines Loans Tax Benefits"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("High credit limits")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    We want to be your one-stop credit provicder for all your\n                    needs.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Transparency.png"),
      "alt": "American Credit Business Loans Transparency"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Transparency")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Our set-up fee and daily factor rate are specified clearly.\n                  ")]), _vm._v(" "), _c('br')])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-3 pt-2",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "75%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_apply_in_minutes.png"),
      "alt": "American Credit invoice financing apply in minutes"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Apply in minutes")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                    Apply in 10 minutes with basic details about your company\n                    and your customer business.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_prequalify_promptly.jpg"),
      "alt": "American Credit invoice financing get approved"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Get approved")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                    American Credit will review your application and make a\n                    decision on the same or the next day.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Invoice_Financing_Submit_Invoice.png"),
      "alt": "American Credit invoice financing submit invoice"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Submit an invoice")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                    Upload your invoice. Established clients can upload invoices\n                    again when needed.\n                  ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "55%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_get_funded_fast.png"),
      "alt": "American Credit invoice financing get funded fast"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Get your payment")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                    You get the rest of the receviable minus the fee after your\n                    customers pays the invoice.\n                  ")]), _vm._v(" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center flow-charm-container"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1 flow-charm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Process_Apply_and_Approved.png"),
      "alt": "American Credit Business Loans Process Apply and Approved"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Apply and approved")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Invoice_Financing_Process_Submit_Invoice.png"),
      "alt": "American Credit Invoice Financing Process Submit Invoice"
    }
  }), _vm._v(" "), _c('p', [_vm._v("$10,000 invoice")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Invoice_Financing_Process_Advanced_to_You.png"),
      "alt": "American Credit Invoice Financing Process Advanced to You"
    }
  }), _vm._v(" "), _c('p', [_vm._v("$8,500 advanced to you")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Invoice_Financing_Process_Paid_to_Net_30.png"),
      "alt": "American Credit Invoice Financing Process Paid to Net 30"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Paid to net 30 by your customer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-15 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Process_Loan_Money.png"),
      "alt": "American Credit Business Loans Process Loan Money"
    }
  }), _vm._v(" "), _c('p', [_vm._v("$9,800 total paid to you")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flow-charm-container"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 what-you-need"
  }, [_c('h4', [_vm._v("Minimum qualifications")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("FICO 600+")]), _vm._v(" "), _c('li', [_vm._v("B2B business with 1+ years tax return")]), _vm._v(" "), _c('li', [_vm._v("$150,000+ annual revenue")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 what-you-need"
  }, [_c('h4', [_vm._v("What you need to apply")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Your business basic information")]), _vm._v(" "), _c('li', [_vm._v("Recent 6 months bank statements")]), _vm._v(" "), _c('li', [_vm._v("Details about the invoice and your customer")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Invoice_Financing_Customer_Voice.png"),
      "alt": "American Credit Invoice Financing Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Alesandra Ale")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("CFO, Silicon Valley Staffing Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v("\n                That’s why we go the extra mile to look at your situation and\n                see if we can help. Unlike some business credit lenders who\n                focus on FICO scores, we look at your business as a whole.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "contact-us"
    }
  }, [_vm._v("Feel free to contact us\n                      "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/Lei-li-formal.jpeg"),
      "alt": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de6d4d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice.vue
// module id = 1964
// module chunks = 5